import src from "IMAGE";
export default { src, width: 237, height: 247, blurWidth: 0, blurHeight: 0};
